const LANES: Record<number, readonly number[]> = { 2: [0.3, 0.7], 3: [0.2, 0.5, 0.8], 4: [0.14, 0.38, 0.62, 0.86] };
export function laneCenters(count: number): readonly number[] {
  if (!LANES[count]) throw new Error('UFO Macerası 2–4 seçenek gerektirir.');
  return LANES[count];
}
export function nearestLane(y: number, count: number): number {
  const lanes = laneCenters(count);
  return lanes.reduce((best, value, index) => Math.abs(value - y) < Math.abs(lanes[best] - y) - 1e-9 ? index : best, 0);
}
export function initialLane(count: number) { laneCenters(count); return Math.floor(count / 2); }
